export default __webpack_public_path__ + "static/media/Ami_Thakkar_Raval_AHV_In_Moms_We_Trust.5ffdbe09.jpg";